module.exports = __webpack_public_path__ + "img/6000.4ee57ca5.jpg";